export default {
    checkStatus (status) { // 检查状态
        for (let key in this) {
            if (this.hasOwnProperty(key)) {
                if (this[key].value === status) {
                    return this[key]
                }
            }
        }
        return { label: '未知', value: -1 }
    },
    ok: { label: '正常', value: 1 },
}